export default "__VITE_ASSET__Dai90zNx__"